import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-background-50 text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
          This page has not been generated
        </h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">
          Page not found
        </p>
        <p className="mt-4 text-base text-foreground-500">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line text-sm"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}